
class PurchaseInvoiceDetailViewController extends InvoiceDetailViewController
{
    static newInstance(): PurchaseInvoiceDetailViewController {
        let vc = new PurchaseInvoiceDetailViewController("purchase-invoice-detail-view");
        vc.initWithResource("layout/invoices/PurchaseInvoiceDetailView.html");
        return vc;
    }
}